import { Controller } from "@hotwired/stimulus"

// Modal confirm dialog for removing a user.
// Triggered by clicking "Remove user" in the dropdown menu.
export default class extends Controller {
  static targets = ["overlay", "userName", "userEmail", "userId", "form"]
  static values = { partnerSlug: String }

  showFromButton(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const userId = btn.dataset.userId
    const userName = btn.dataset.userName
    const userEmail = btn.dataset.userEmail
    this.userNameTarget.textContent = userName
    this.userEmailTarget.textContent = userEmail
    this.userIdTarget.value = userId
    this.formTarget.action = `/partners/${this.partnerSlugValue}/remove_user`
    this.overlayTarget.classList.remove("hidden")
  }

  cancel() {
    this.overlayTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
